<i18n>
{
	"no": {
		"orderNumber": "Oppdrag",
		"despatchParty": "Avsender",
		"deliveryParty": "Mottaker",
		"customer": "Kunde",
		"noOrders" : "Ingen oppdrag funnet. Sjekk feilmeldinger",
		"status": "Status",
		"status/cancelled": "Annullert",
		"status/draft": "Kladd",
		"status/ready": "Klar",
		"status/planned": "Planlagt",
		"status/rejected": "Avslått",
		"status/unsuccessful": "Bomtur",
		"status/requested": "Forespurt",
		"status/received": "Mottatt",
		"status/accepted": "Akseptert",
		"status/readyForPickup": "Klar for henting",
		"status/loaded": "Lastet",
		"status/unloaded": "Losset"
	},
	"en": {
		"orderNumber": "Order",
		"despatchParty": "Despatch party",
		"deliveryParty": "Delivery party",
		"customer": "Customer",
		"noOrders" : "No orders found. Check errors",
		"status": "Status",
		"status/cancelled": "Cancelled",
		"status/draft": "Draft",
		"status/ready": "Ready",
		"status/planned": "Planned",
		"status/rejected": "Rejected",
		"status/unsuccessful": "Unsuccessful",
		"status/requested": "Requested",
		"status/received": "Received",
		"status/accepted": "Accepted",
		"status/readyForPickup": "Ready for Pickup",
		"status/loaded": "Loaded",
		"status/unloaded": "Unloaded"
	}
}

</i18n>
<template>
	<div style="height:500px">
		<t-grid
			v-if="!noOrders"
			ref="ediOrders"
			:key="'ediOrders'"
			:columnDefinitions="columnDefinitions"
			:defaultColumnDefinition="defaultColumnDefinition"
			:rowHeight="50"
			:showFilters="false"
			:items="orders"
			@rowDoubleClick="onOpenOrder"
		>
			<template v-slot:status="{ item }">
				<t-timpex-icon
					:icon="getStatusIcon(item)"
					:color="getStatusColor(item)"
					:title="getStatusTitle(item)"
					size="md"
					style="padding-left: 3px;"
				/>
			</template>
			<template v-slot:despatchParty="{ item }">
				<div v-if="item.despatchParty" style="height: 16px;">{{ item.despatchParty.name }}</div>
				<div v-if="item.despatchParty" class="grid-cell-sub-line" :class="{'missing-geo-data': !item.despatchParty.latitude || !item.despatchParty.longitude }">{{ item.despatchParty.street }}, {{ item.despatchParty.postalCode }} {{ item.despatchParty.postalPlace }}</div>
			</template>
			<template v-slot:deliveryParty="{ item }">
				<div v-if="item.deliveryParty" style="height: 16px;">{{ item.deliveryParty.name }}</div>
				<div v-if="item.deliveryParty" class="grid-cell-sub-line" :class="{'missing-geo-data': !item.deliveryParty.latitude || !item.deliveryParty.longitude }">{{ item.deliveryParty.street }}, {{ item.deliveryParty.postalCode }} {{ item.deliveryParty.postalPlace }}</div>
			</template>
			
		
		</t-grid>
		<t-no-content-panel
			v-else
			:text="$tc('noOrders')"
			icon="order-warning"
		/>
		
	</div>
</template>

<script>

import { eventBus, statuses, goodsTypesIcons } from '@/core';
import getOrdersByIds from './request/getOrdersByIds';
export default {
	props: {
		ordersAndErrors: Object
	},
	data() {
		return {
			columnDefinitions: [
				{
					field: 'status',
					displayName: this.$t('status'),
					width:120,
				},
				{
					field: 'orderNumber',
					displayName: this.$t('orderNumber'),
				},
				{
					field: 'despatchParty',
					displayName: this.$t('despatchParty'),
				},
				{
					field: 'deliveryParty',
					displayName: this.$t('deliveryParty'),
				},
				{
					field: 'customer.name',
					displayName: this.$t('customer')
				}
			],
			defaultColumnDefinition:{
				resizable: true,
			},
			orders: []
		};
	},

	computed: {
		noOrders() {
			return this.ordersAndErrors.orderIds.length === 0;
		}
	},
	async created() {
		let orders = await getOrdersByIds(this.ordersAndErrors.orderIds);
		this.orders = orders;
	},
	methods: {
		getOperationalStatus(status) {
			return statuses.operational(status);
		},
		getEconomicalStatus(status) {
			return statuses.economical(status);
		},
		getOperationalStatusColor(status) {
			return statuses.color(status);
		},
		getEconomicalStatusColor(status) {
			return statuses.economicalStatusColor(status);
		},

		getStatusIcon(item) {
			return goodsTypesIcons(item.goodsType);
		},
		getStatusColor(item) {
			return statuses.color(item.status);
		},
		getStatusTitle(item) {
			return this.$t(`status/${statuses.operational(item.status)}`);
		},
		onOpenOrder(id) {
			let order = this.orders.find(x => x.id === id);
			eventBus.queue('setEditOrderByQuickSearch', order.orderNumber);
		}
	},


};
</script>

<style>

</style>